import React from "react";
import styled from "styled-components";
import { Footer, Header, Container } from "..";

interface LayoutProps {
  children: React.ReactNode;
}

const Main = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Body = styled.div`
  flex: 1;
`;

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Main>
      <Header />
      <Body>
        <Container>{children}</Container>
      </Body>
      <Footer />
    </Main>
  );
};
